import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["reasonOption", "submitButton", "reportButton"]

  connect() {
    console.log("Document fraud report controller connected")
  }

  showModal(event) {
    // Prevent default link behavior
    event.preventDefault()
    
    // Find the modal element
    const modal = document.getElementById('fraudReportModal')
    if (modal) {
      // Create a new Bootstrap modal instance and show it
      const bootstrapModal = new bootstrap.Modal(modal)
      bootstrapModal.show()
    }
  }
  
  selectReason(event) {
    // Remove selected class from all options
    this.reasonOptionTargets.forEach(opt => {
      opt.classList.remove('selected')
    })
    
    // Add selected class to clicked option
    const option = event.currentTarget
    option.classList.add('selected')
    
    // Get the fraud reason value and set it to hidden input
    const reasonValue = option.getAttribute('data-reason-value')
    const hiddenInput = document.querySelector('input[name="reported_as_fraud_reason"]')
    if (hiddenInput) {
      hiddenInput.value = reasonValue
    }
    
    // Enable submit button when a reason is selected
    if (this.hasSubmitButtonTarget) {
      this.submitButtonTarget.disabled = false
    }
  }
}